import type { DocumentNode } from '@trello/graphql';

export enum RootId {
  ':idMember',
  ':idBoard',
  ':idCard',
  ':searchTerm',
  ':idOrganization',
}

export enum ModelName {
  Member = 'Member',
  Board = 'Board',
  Card = 'Card',
  Search = 'Search',
  Organization = 'Organization',
}

export interface RouteQuery {
  apiUrl: string;
  query: DocumentNode;
  rootId: keyof typeof RootId;
  appendRootIdToUrl?: boolean;
  modelName: ModelName;
}

export interface RouteQueries {
  [k: string]: RouteQuery[];
}

export interface SimpleRequestObject {
  url: string;
  rootId: keyof typeof RootId;
  operationName: string;
}

export interface SimpleRequestMap {
  [k: string]: SimpleRequestObject[];
}

export interface SimpleOperationMap {
  [k: string]: SimpleRequestObject;
}

export interface QuickloadUrl {
  url: string;
  operationName: string;
}

export type QuickloadUrls = QuickloadUrl[];

export type QuickloadError = [number, string];
export type QuickloadData = [JSON | JSON[] | null, XMLHttpRequest];

export type QuickloadResponse = QuickloadData | null | undefined;

export type Callback = (
  error?: QuickloadError | null,
  data?: QuickloadData | null,
) => void;

export interface Preload {
  isLoading: boolean;
  callbacks: Callback[];
  start: number;
  used: boolean;
  url: string;
  data?: QuickloadData | null;
  error?: QuickloadError | null;
  traceId?: string;
}

export type CleanPreload = Omit<Preload, 'callbacks'>;

export interface QuickLoad {
  load: (url: string, next: Callback) => void;
  clear: () => void;
  init: () => void;
}

export type PreloadDefintion = [url: string, operationName: string];
